module.exports = __webpack_public_path__ + "static/media/icon.c4e459c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon.svg
// module id = 380
// module chunks = 0